import { useLang } from "@/contexts/LangContext";
import SectionReveal from "@/components/SectionReveal";

const IMAGES = [
  "/img/cuisine/mapo_tofu.png",
  "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?auto=format&fit=crop&w=900&q=80", // cantonese dim sum (existing, looks great)
  "/img/cuisine/peking_duck.png",
  "/img/cuisine/xiaolongbao.png",
  "/img/cuisine/hunan_pork.png",
  "/img/cuisine/xinjiang_lamb.png",
];

const Cuisine = () => {
  const { t } = useLang();

  return (
    <section
      id="cuisine"
      data-testid="cuisine-section"
      className="bg-[#F7F5F0] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionReveal className="max-w-3xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#C62828] font-semibold mb-4">
            ✦ {t.cuisine.eyebrow}
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#121212] leading-[1.05]">
            {t.cuisine.title}
          </h2>
        </SectionReveal>

        {/* Mobile: horizontal carousel; Desktop: grid */}
        <div
          data-testid="cuisine-carousel-mobile"
          className="mt-12 md:hidden -mx-6 px-6 overflow-x-auto snap-x snap-mandatory flex gap-4 pb-4 scrollbar-hide"
        >
          {t.cuisine.items.map((c, i) => (
            <div
              key={c.name}
              data-testid={`cuisine-card-mobile-${i}`}
              className="snap-center flex-shrink-0 w-[78%] aspect-[3/4] relative overflow-hidden border border-[#EAE6DF] bg-white group"
            >
              <img
                src={IMAGES[i]}
                alt={c.dish}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 text-white">
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">{c.flavor}</p>
                <h3 className="mt-1 font-heading text-2xl">{c.name}</h3>
                <p className="text-sm text-white/80 mt-0.5">{c.dish}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {t.cuisine.items.map((c, i) => (
            <SectionReveal
              key={c.name}
              delay={i * 0.08}
              data-testid={`cuisine-card-${i}`}
              className="group relative overflow-hidden border border-[#EAE6DF] bg-white"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={IMAGES[i]}
                  alt={c.dish}
                  className="w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-7 bg-gradient-to-t from-black via-black/70 to-transparent text-white">
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
                  {c.flavor}
                </p>
                <h3 className="mt-2 font-heading text-2xl">{c.name}</h3>
                <p className="text-sm text-white/80 mt-1">{c.dish}</p>
              </div>
            </SectionReveal>
          ))}
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
};

export default Cuisine;
